import { CULTURED_GRAY, WHITE_COLOR } from "@/controls/shared/constants/colors";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useTableStyles = makeStyles((theme: Theme) => ({
	materialTable: {
		"& .ag-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			fontSize: 12,
			lineBreak: "auto",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			border: "0 !important",
			wordBreak: "break-word",
		},
		"& .ag-icon-menu": {
			display: "none",
		},
		"& .ag-header-group-cell": {
			color: "black",
		},
		"& .ag-header-group-cell-label ": {
			textAlign: "center !important",
			justifyContent: "center",
			fontSize: ".8rem !important",
			color: "black",
		},
		"& .ag-root-wrapper": {
			borderRadius: 3,
		},
		"& .ag-header-cell-label": {
			justifyContent: "center",
			fontSize: ".8rem !important",
			padding: 2,
		},
		"& .ag-center-aligned-header": {
			textAlign: "center !important",
		},
		"& .ag-header-cell, .ag-header-cell-group-cell, .ag-header-group-text": {
			padding: 2,
			color: "black",
		},
		"& .ag-center-aligned-cell": {
			textAlign: "center !important",
		},
		"& .ag-button-cell": {
			padding: "0px !important",
			textAlign: "center !important",
			cursor: "pointer",
		},
		"& .info-limit": {
			color: "#000",
			backgroundColor: "#b2e5ed",
			fontWeight: 600,
		},
		"& .first-column-cell": {
			fontSize: ".8rem !important",
			fontWeight: "bold",
			color: "black",
		},
		"& .ag-status-bar": {
			backgroundColor: theme.palette.background.paper,
			color: theme.palette.text.primary,
			padding: theme.spacing(0.5, 1),
			fontSize: 13,
			fontWeight: "bold",
			border: "none",
		},
		height: "20.5rem",
	},
	strandTable: {
		"& .ag-header-cell-label": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
	},
	dynamicHeight: {
		height: (props?: { rowCount?: number }) => {
			const rowCount = props?.rowCount ?? 4; // Default to 4 if rowCount is not provided
			return `${Math.min(350 + (rowCount - 4) * 50, 550)}px`;
		},
		// 350px base for 4 rows, 50px for each additional row, maximum 550px (for 8 rows)
	},
	borderAgGridTable: {
		border: "1px solid #ccc",
		borderRadius: "4px",
		padding: "3px ",
	},
	manualAutoButton: {
		minWidth: "5px",
		padding: "6px 8px",
		cursor: "auto",
	},
	fileTabsRoot: {
		background: "transparent",
		minHeight: 0,
		borderBottom: "none",
	},
	fileTabsIndicator: {
		display: "none",
	},
	fileTabRoot: {
		backgroundColor: CULTURED_GRAY,
		border: `1px solid ${theme.palette.divider}`,
		borderBottom: `1px solid ${theme.palette.divider}`,
		borderTopLeftRadius: theme.shape.borderRadius,
		borderTopRightRadius: theme.shape.borderRadius,
		textTransform: "none",
		minHeight: 56,
		minWidth: 150,
		fontSize: 18,
		padding: theme.spacing(1.5, 4),
		marginRight: theme.spacing(0.5),
		position: "relative",
		marginBottom: "-1px",
		"&:hover": {
			backgroundColor: theme.palette.action.hover,
		},
		"&$fileTabSelected": {
			backgroundColor: WHITE_COLOR,
			fontWeight: theme.typography.fontWeightMedium,
			borderBottom: "none",
			marginBottom: "-2px",
			zIndex: 10,
		},
	},
	// 3) empty marker rule for “selected”
	fileTabSelected: {},
	container: {
		display: "flex",
		flexWrap: "nowrap",
		width: "100%",
	},
	field: {
		flex: 1,
		minWidth: 0,
	},
	field2: {
		flex: 2,
		minWidth: 0,
	},
	leftField: {
		"& .MuiOutlinedInput-root": {
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			borderRight: "none",
		},
	},
	rightField: {
		"& .MuiOutlinedInput-root": {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0,
		},
	},
	checkbox: {
		padding: 0,
		margin: 0,
	},
	inputAdornment: {
		margin: 0,
	},
	input: {
		paddingRight: theme.spacing(1),
	},
	// Notes
	outlinedTextarea: {
		width: "100%",
		padding: "10px 12px",
		border: `1px solid ${theme.palette.grey[400]}`,
		borderRadius: theme.shape.borderRadius,
		fontFamily: theme.typography.fontFamily,
		fontSize: theme.typography.fontSize,
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		"&:hover": {
			borderColor: theme.palette.text.primary,
		},
		"&:focus": {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
			outline: "none",
		},
		"&::placeholder": {
			color: theme.palette.text.secondary,
			opacity: 1,
		},
	},
	assetTitle: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		userSelect: "none",
		height: "100%",
	},
}));

export const useManualAutoButtonStyles = makeStyles((theme) => ({
	manualAutoButton: {
		minWidth: "5px",
		width: "25px",
		height: "25px",
		padding: "6px 8px",
		cursor: "auto",
	},
}));
